import { createFileRoute } from '@tanstack/react-router';
import { SettingsTab } from '@/pages/workspaces/integrations/sql-sync/import/tabs/settings-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

/** The Settings tab: the import's schedule, target and source database. */
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings',
)({
  component: withRumPageRendered(SettingsTab),
});
